/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourCompleteInput = {
    tourCompleted?: boolean | null;
    clientMutationId?: string | null;
};
export type TourCompleteMutationVariables = {
    input: TourCompleteInput;
};
export type TourCompleteMutationResponse = {
    readonly userTourComplete: {
        readonly clientMutationId: string | null;
        readonly tourCompleted: boolean | null;
    } | null;
};
export type TourCompleteMutation = {
    readonly response: TourCompleteMutationResponse;
    readonly variables: TourCompleteMutationVariables;
};



/*
mutation TourCompleteMutation(
  $input: TourCompleteInput!
) {
  userTourComplete(input: $input) {
    clientMutationId
    tourCompleted
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TourCompletePayload",
    "kind": "LinkedField",
    "name": "userTourComplete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tourCompleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourCompleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourCompleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b84be127c7d240fac9de8f78632bdf02",
    "id": null,
    "metadata": {},
    "name": "TourCompleteMutation",
    "operationKind": "mutation",
    "text": "mutation TourCompleteMutation(\n  $input: TourCompleteInput!\n) {\n  userTourComplete(input: $input) {\n    clientMutationId\n    tourCompleted\n  }\n}\n"
  }
};
})();
(node as any).hash = '0d92755fe76af5e4daf243eae6d8426f';
export default node;
